/**
 * GBPE rewrites nav links to their authenticated destinations, so every batch
 * of nav markup needs a swap pass once a user is signed in. Markup and auth
 * arrive independently — a flyout can land before GBPE resolves, or long after
 * — so both sides call this and whichever happens last does the work.
 *
 * Auth state is read from `window.gbpe` on every call rather than cached: the
 * nav and account elements ship as separate IIFE bundles and cannot share
 * module state.
 */

let scheduled = false

export function swapAuthLinks(): void {
	// A burst of lazy-loaded panels resolving together only needs one pass.
	if (scheduled) {
		return
	}
	scheduled = true

	Promise.resolve().then(() => {
		scheduled = false

		const authLinkService = window.gbpe?.authLinkService
		if (window.gbpe?.auth?.currentAuthState !== 1 || typeof authLinkService?.swapLinks !== 'function') {
			return
		}

		try {
			authLinkService.swapLinks()
		} catch (error) {
			window.console.error(`ERROR:  Failed to swap authenticated nav links: ${error}`)
		}
	})
}
